import { render, staticRenderFns } from "./PostProsjekt.vue?vue&type=template&id=8d396630&"
import script from "./PostProsjekt.vue?vue&type=script&lang=js&"
export * from "./PostProsjekt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports